var render = function () {
  var _vm$currentRound$answ, _vm$currentRound$answ2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'beginning-letter',
      "customContentContainerStyles": {
        height: 'calc(100% - 55px)'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('section', {
    staticClass: "focusable",
    attrs: {
      "slot": "content",
      "tabindex": "0",
      "id": "beginning-letter-wrapper"
    },
    slot: "content"
  }, [_vm.activityData && _vm.currentRound ? _c('div', {
    staticClass: "round-image-container ",
    attrs: {
      "id": "beginning-letter"
    }
  }, [_c('section', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    staticClass: "round-image",
    attrs: {
      "src": (_vm$currentRound$answ = _vm.currentRound.answerImage) === null || _vm$currentRound$answ === void 0 ? void 0 : (_vm$currentRound$answ2 = _vm$currentRound$answ.image) === null || _vm$currentRound$answ2 === void 0 ? void 0 : _vm$currentRound$answ2.src,
      "alt": _vm.currentRound.answer
    }
  }), _vm.showAnswer ? _c('figcaption', {
    domProps: {
      "textContent": _vm._s(_vm.imageName)
    }
  }) : _vm._e()]), !_vm.hideKey && !_vm.showAnswer ? _c('span', {
    class: ['current-key-container keyStyle ', ("to-" + (_vm.getKeyType())), _vm.getKeyColor()],
    domProps: {
      "textContent": _vm._s(_vm.currentRound.letter)
    }
  }) : _vm._e()]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }